import { timeout } from "lib/actions/util";

export async function pollUntil(
  intervalMs: number,
  timeoutMs: number,
  evaluation: () => Promise<boolean>,
) {
  let interrupt = false;
  const polling = (async () => {
    while (!interrupt) {
      if (await evaluation()) return;
      await new Promise((res) => setTimeout(res, intervalMs));
    }
  })();
  return timeout(timeoutMs, polling).finally(() => {
    interrupt = true;
  });
}
